import { createSvgIcon } from "@material-ui/core/utils";
import React from "react";

export const DiscountsIcon = createSvgIcon(
  <svg
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.7793 2C13.9493 2 13.1533 2.32973 12.5664 2.91665L2.91665 12.5664C1.69445 13.7886 1.69445 15.7701 2.91665 16.9923L7.00768 21.0834C8.22987 22.3055 10.2114 22.3056 11.4336 21.0834L21.0834 11.4336C21.6703 10.8467 22 10.0507 22 9.22066V6.25466C22 5.42463 21.6703 4.6286 21.0834 4.04168L19.9583 2.91665C19.3714 2.32973 18.5754 2 17.7453 2H14.7793ZM14.0417 4.39197C14.2373 4.19633 14.5027 4.08642 14.7793 4.08642H17.7453C18.022 4.08642 18.2874 4.19633 18.483 4.39197L19.608 5.517C19.8037 5.71264 19.9136 5.97798 19.9136 6.25466V9.22066C19.9136 9.49734 19.8037 9.76268 19.608 9.95832L12.3503 17.2161L6.78394 11.6497L14.0417 4.39197ZM5.30862 13.125L10.875 18.6914L9.95832 19.608C9.55093 20.0154 8.8904 20.0154 8.483 19.608L4.39197 15.517C3.98457 15.1096 3.98457 14.4491 4.39197 14.0417L5.30862 13.125ZM16.2623 9.30248C17.1266 9.30248 17.8272 8.60189 17.8272 7.73766C17.8272 6.87344 17.1266 6.17285 16.2623 6.17285C15.3981 6.17285 14.6975 6.87344 14.6975 7.73766C14.6975 8.60189 15.3981 9.30248 16.2623 9.30248Z"
      fill="currentColor"
    />
  </svg>,
  "DiscountsIcon"
);
